import { Axios } from "@/utils/axios";

export const deleteQuestion = (id: number) => {
  return Axios.delete(`/questions/${id}/`);
};
